import React, { useState } from "react";
import { Heading } from "../../components/style/Heading";
import { ModelPicker } from "./components/ModelPicker";

export const Models = ({
  items,
  isActive,
  onComplete,
  activeProduct,
  setLegPrice,
  manager,
}) => {
  const { state } = manager;

  return (
    <>
      <Heading
        isActive={isActive}
        completed={state.completedModels}
        title={"Model"}
      />
      <div className="styling-wrap__contents | js-conf-styling-wrap-content">
        {!state.completedModels && isActive && items && (
          <ModelPicker
            title="Izbor modela"
            items={items}
            material={activeProduct.board?.Materijal}
            dims={activeProduct?.dims?.length?.value}
            thickness={activeProduct?.board?.Debljina}
            setCompleted={() => {
              manager.setState((prev) => ({
                ...prev,
                completedModels: true,
              }));
            }}
            onComplete={onComplete}
            handleColorClick={(item) => manager.selectModel(item)}
            setLegPrice={setLegPrice}
          />
        )}
      </div>
    </>
  );
};
